<form #theForm="ngForm" (ngSubmit)="restart()" [formGroup]="formData" novalidate>

  <div class="btn-toolbar">
    <div class="btn-group">
      <button type="submit" class="btn btn-primary" [disabled]="formData.invalid">Done</button>
    </div>
  </div>

  <h1>Import completed successfully</h1>
</form>
